const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

const toMinutes = (value) => {
  if (!value) return null;
  const [hours, minutes] = String(value).split(':').map(Number);
  return Number.isFinite(hours) && Number.isFinite(minutes) ? hours * 60 + minutes : null;
};

const isInWindow = (minutes, startValue, endValue, previousDay = false) => {
  const start = toMinutes(startValue);
  const end = toMinutes(endValue);
  if (start == null || end == null) return null;
  if (start <= end) return !previousDay && minutes >= start && minutes < end;
  return previousDay ? minutes < end : minutes >= start;
};

const isInStoreHours = (config, date) => {
  const dayIndex = date.getDay();
  const day = DAYS[dayIndex];
  const previousDay = DAYS[(dayIndex + 6) % 7];
  const minutes = date.getHours() * 60 + date.getMinutes();

  const todayOpen = isInWindow(minutes, config[`${day}Start`], config[`${day}End`]);
  const previousOpen = isInWindow(minutes, config[`${previousDay}Start`], config[`${previousDay}End`], true);
  if (!todayOpen && !previousOpen) return false;

  const activeDay = todayOpen ? day : previousDay;
  const inBreak = isInWindow(
    minutes,
    config[`${activeDay}BreakStart`],
    config[`${activeDay}BreakEnd`],
    activeDay === previousDay
  );
  return !inBreak;
};

export const isServiceAvailable = (config, serviceMode, date = new Date()) => {
  if (!config || serviceMode === 'Dine-in') return true;
  if (!isInStoreHours(config, date)) return false;

  const suffix = serviceMode === 'Delivery' ? 'Delivery' : 'Takeaway';
  const dayIndex = date.getDay();
  const day = DAYS[dayIndex];
  const previousDay = DAYS[(dayIndex + 6) % 7];
  const minutes = date.getHours() * 60 + date.getMinutes();
  const todayWindow = isInWindow(minutes, config[`${day}${suffix}Start`], config[`${day}${suffix}End`]);
  const previousWindow = isInWindow(minutes, config[`${previousDay}${suffix}Start`], config[`${previousDay}${suffix}End`], true);

  // No complete window for the current day means no additional restriction.
  if (todayWindow == null) return true;
  return Boolean(todayWindow || previousWindow);
};

export const serviceTimeFields = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
  .flatMap((day) => ['Takeaway', 'Delivery'].flatMap((service) => [`${day}${service}Start`, `${day}${service}End`]));
